(function() {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	$.fn.dropdownMenu = function() {

		var generateDropdownToggle = function(dropdownMenus) {
			dropdownMenus.each(function() {
				var dropdown = $(this);
				var parentMenu = dropdown.closest('li');
				var toggler = $('<a href="#" class="dropdown-toggle"></a>').appendTo(parentMenu);

				toggler.click(function(e) {
					e.preventDefault();

					parentMenu.toggleClass('open');
				});
			});
		}

		return this.each(function() {
			var menu = $(this);
			var dropdownMenus = menu.find('ul.hs-menu-children-wrapper');

			generateDropdownToggle(dropdownMenus);
		});
	};

	$('#header nav, #site-header nav').dropdownMenu();

})();